import gql from 'graphql-tag';

export const GET_SERVICE_REQUEST_FIXED_FILES = gql`
	query GetServiceRequestFixed($id: String!) {
		serviceRequest(id: $id) {
			id
			completedFiles {
				id
				type
				status
				allowFixRequest
				tags
				isActive
				filename
				thumbnailUrl
				webUrl
				watermarkUrl
				isVisible
			}
			service {
				id
			}
		}
	}
`;

export const GET_SERVICE_FOR_FIXED_FILES = gql`
	query ServiceAddressForFixedFiles($id: String!) {
		service(id: $id) {
			id
			type
			photographer {
				id
			}
		}
	}
`;
